import { mainUrl } from "../../../api/apiSettings";

// POST - https://4majc3no2f.execute-api.sa-east-1.amazonaws.com/dev/tag
export const TAG_CREATE = `${mainUrl}/tag`;

// GET - https://4majc3no2f.execute-api.sa-east-1.amazonaws.com/dev/tag
export const TAG_QUERY = `${mainUrl}/tag`;
